// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################

export function updatePracovnik_022EAEv1(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "PracovnikVO":
            return updatePracovnikVO_A3E517v1(data);
        case "NeznamyPracovnikVO":
            return updateNeznamyPracovnikVO_E54867v1(data);
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapPracovnik_022EAEv1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePracovnik_022EAEv1(data[key]);
    });
    return result;
}

export function updateListPracovnik_022EAEv1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePracovnik_022EAEv1);
}

export function updateUser_3D9846(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'UserVO',
    };


    return result;
}

export function updateMapUser_3D9846(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateUser_3D9846(data[key]);
    });
    return result;
}

export function updateListUser_3D9846(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateUser_3D9846);
}

export function updateQsignSignConfVO_1F0072(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.certInfo !== "undefined" && data.certInfo) {
        result.certInfo = updateModuleCertInfo_0C626Ev1(data.certInfo);
    }

    return result;
}

export function updateMapQsignSignConfVO_1F0072(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateQsignSignConfVO_1F0072(data[key]);
    });
    return result;
}

export function updateListQsignSignConfVO_1F0072(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateQsignSignConfVO_1F0072);
}

export function updateCreateSignRequest_7F4312(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'CreateSignRequestVO',
    };

    if (typeof data.userFrom !== "undefined" && data.userFrom) {
        result.userFrom = updateUser_3D9846(data.userFrom);
    }
    if (typeof data.userSign !== "undefined" && data.userSign) {
        result.userSign = updateUser_3D9846(data.userSign);
    }
    if (typeof data.documents !== "undefined" && data.documents) {
        result.documents = updateListDocument_5ECB9F(data.documents);
    }

    return result;
}

export function updateMapCreateSignRequest_7F4312(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateCreateSignRequest_7F4312(data[key]);
    });
    return result;
}

export function updateListCreateSignRequest_7F4312(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateCreateSignRequest_7F4312);
}

export function updateOrganizacniJednotka_8A8817v1(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'OrganizacniJednotkaVO',
    };


    return result;
}

export function updateMapOrganizacniJednotka_8A8817v1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateOrganizacniJednotka_8A8817v1(data[key]);
    });
    return result;
}

export function updateListOrganizacniJednotka_8A8817v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateOrganizacniJednotka_8A8817v1);
}

export function updateConfigurationVO_EF85C0(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.signers !== "undefined" && data.signers) {
        result.signers = updateListSignerVO_993E48(data.signers);
    }

    return result;
}

export function updateMapConfigurationVO_EF85C0(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateConfigurationVO_EF85C0(data[key]);
    });
    return result;
}

export function updateListConfigurationVO_EF85C0(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateConfigurationVO_EF85C0);
}

export function updateCreateSignRequestVO_D7BD84(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.userFrom !== "undefined" && data.userFrom) {
        result.userFrom = updateUser_3D9846(data.userFrom);
    }
    if (typeof data.userSign !== "undefined" && data.userSign) {
        result.userSign = updateUser_3D9846(data.userSign);
    }
    if (typeof data.documents !== "undefined" && data.documents) {
        result.documents = updateListDocument_5ECB9F(data.documents);
    }

    return result;
}

export function updateMapCreateSignRequestVO_D7BD84(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateCreateSignRequestVO_D7BD84(data[key]);
    });
    return result;
}

export function updateListCreateSignRequestVO_D7BD84(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateCreateSignRequestVO_D7BD84);
}

export function updatePracovnikVO_A3E517v1(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.organizacniJednotka !== "undefined" && data.organizacniJednotka) {
        result.organizacniJednotka = updateOrganizacniJednotka_8A8817v1(data.organizacniJednotka);
    }

    return result;
}

export function updateMapPracovnikVO_A3E517v1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePracovnikVO_A3E517v1(data[key]);
    });
    return result;
}

export function updateListPracovnikVO_A3E517v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePracovnikVO_A3E517v1);
}

export function updateCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "HsmCertificateInfo":
            return data;
        case "McCertificateInfo":
            return data;
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateCertificateInfo_0D10F4(data[key]);
    });
    return result;
}

export function updateListCertificateInfo_0D10F4(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateCertificateInfo_0D10F4);
}

export function updateSignerVO_993E48(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.pracovnik !== "undefined" && data.pracovnik) {
        result.pracovnik = updatePracovnik_022EAEv1(data.pracovnik);
    }

    return result;
}

export function updateMapSignerVO_993E48(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSignerVO_993E48(data[key]);
    });
    return result;
}

export function updateListSignerVO_993E48(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSignerVO_993E48);
}

export function updateNeznamyPracovnikVO_E54867v1(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.organizacniJednotka !== "undefined" && data.organizacniJednotka) {
        result.organizacniJednotka = updateOrganizacniJednotka_8A8817v1(data.organizacniJednotka);
    }

    return result;
}

export function updateMapNeznamyPracovnikVO_E54867v1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateNeznamyPracovnikVO_E54867v1(data[key]);
    });
    return result;
}

export function updateListNeznamyPracovnikVO_E54867v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateNeznamyPracovnikVO_E54867v1);
}

export function updateSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.certificateInfo !== "undefined" && data.certificateInfo) {
        result.certificateInfo = updateCertificateInfo_0D10F4(data.certificateInfo);
    }

    return result;
}

export function updateMapSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSigningRequest_C85543(data[key]);
    });
    return result;
}

export function updateListSigningRequest_C85543(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSigningRequest_C85543);
}

export function updateModuleCertInfo_0C626Ev1(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "MarbesCertInfoVO":
            return data;
        case "HsmCertInfoVO":
            return data;
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapModuleCertInfo_0C626Ev1(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateModuleCertInfo_0C626Ev1(data[key]);
    });
    return result;
}

export function updateListModuleCertInfo_0C626Ev1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateModuleCertInfo_0C626Ev1);
}

export function updateDocument_5ECB9F(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DocumentVO',
    };


    return result;
}

export function updateMapDocument_5ECB9F(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDocument_5ECB9F(data[key]);
    });
    return result;
}

export function updateListDocument_5ECB9F(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDocument_5ECB9F);
}
